/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// import axios from 'axios';
import $http from '../../plugins/axios';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const invokegetOperationData = async (url: string, params: any) => {
  let res;
  // eslint-disable-next-line camelcase
  await $http.post(url, params).then((response) => {
    res = response.data;
    return res;
  });
  return res;
};
export const updateLearnerRecord = async (url: string, params: any) => {
  const savedRes = await $http.post(url, params);
  return savedRes;
  // let res;
  // // eslint-disable-next-line camelcase
  // await $http.post(url, params).then((response) => {
  //   res = response.data;
  //   return res;
  // });
  // return res;
};
export const invokeAssignProxyToPlagiarizedLearners = async (url: string, params: any) => {
  // let res;
  // // eslint-disable-next-line camelcase
  // await $http.post(url, params).then((response) => {
  //   res = response.data.operationData;
  //   return res;
  // });
  // return res;
  const res = await $http.post(url, params);
  return res;
};
export const invokeDeleteLearnerJourney = async (url: string) => {
  let res;
  // eslint-disable-next-line camelcase
  await $http.get(url).then((response) => {
    res = response.data;
    return res;
  });
  return res;
};

export const invokeHoldLearnerJourney = async (url: string, data: any) => {
  let res;
  // eslint-disable-next-line camelcase
  await $http.post(url, data).then((response) => {
    res = response.data;
    return res;
  });
  return res;
};

export const invokegetSkillProf = async (url: string) => {
  let res;
  // eslint-disable-next-line camelcase
  await $http.get(url).then((response) => {
    // console.log(response.data.sys_settings);
    res = response.data;
    return res;
  });
  return res;
};
// export const invokeTemplateSeed = async (url: string) => {
//   let res;
//   await $http.get(url).then((response) => {
//     res = response.data;
//     return res;
//   });
//   return res;
// };
// export const invokeProxyReviewSeed = async (url: string) => {
//   let res;
//   await $http.get(url).then((response) => {
//     res = response.data;
//     return res;
//   });
//   return res;
// };
// export const invokeMigrateS3Task = async (url: string) => {
//   let res;
//   await $http.get(url).then((response) => {
//     res = response.data;
//     return res;
//   });
//   return res;
// };
// export const invokeMigrateS3LA = async (url: string) => {
//   let res;
//   await $http.get(url).then((response) => {
//     res = response.data;
//     return res;
//   });
//   return res;
// };
// export const invokeMigrateS3Review = async (url: string) => {
//   let res;
//   await $http.get(url).then((response) => {
//     res = response.data;
//     return res;
//   });
//   return res;
// };
// export const invokeMigrateCohortProgram = async (url: string) => {
//   let res;
//   await $http.get(url).then((response) => {
//     res = response.data;
//     return res;
//   });
//   return res;
// };
// export const invokeMigrateCohortLA = async (url: string) => {
//   let res;
//   await $http.get(url).then((response) => {
//     res = response.data;
//     return res;
//   });
//   return res;
// };
// export const invokeGetUserRole = async (url: string) => {
//   let res;
//   await $http.get(url).then((response) => {
//     res = response.data;
//     return res;
//   });
//   return res;
// };
